import {black} from 'material-ui/styles/colors';

const styles = {
    container: {
        height: 40,
        width: '90%'
    },
    iconButton: {
        float: 'left',
        paddingTop: 11,
        marginLeft: 20
    },
    textField: {
        display: "inline-block",
        width: "calc(100% - 60px)",
        color: black,
        borderRadius: 4,
        marginLeft: 10
    },
    inputStyle: {
        color: black,
        paddingLeft: 5
    },
    hintStyle: {
        color: black,
        paddingLeft: 5
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/common/SearchBox/SearchBox.css.js